import { Component, OnInit } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { TripService } from '../../../services/trip/trip.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tripmapview',
  templateUrl: './tripmapview.component.html',
  styleUrls: ['./tripmapview.component.scss']
})
export class TripmapviewComponent implements OnInit {

  inPlanningCount: number = 0;
  scheduledCount: number = 0;
  intransitCount: number = 0;
  completedCount: number = 0;
  incomplete: number = 0;

  zoom: number = 13;
  lat: number = 18.533989;
  lng: number = 73.825592;
  OrderMapMarker: any;
  markers: any;
  markersArr = [];
  constructor(
    private tripService: TripService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    let type = 'unplanned';
    //send type here
    this.generateMapData();

    this.tripService.getTripCountByStatus(this.datePipe.transform(new Date(), 'yyyy-MM-dd'),this.datePipe.transform(new Date(), 'yyyy-MM-dd')).subscribe(res => {
      console.log(res);
      if (this.searchArraryForCount(res, 'TRIP_STATE_IN_PLANNING') != undefined) {
        this.inPlanningCount = this.searchArraryForCount(res, 'TRIP_STATE_IN_PLANNING').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_SCHEDULED') != undefined) {
        this.scheduledCount = this.searchArraryForCount(res, 'TRIP_STATE_SCHEDULED').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_IN_TRANSIT') != undefined) {
        this.intransitCount = this.searchArraryForCount(res, 'TRIP_STATE_IN_TRANSIT').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_COMPLETED') != undefined) {
        this.completedCount = this.searchArraryForCount(res, 'TRIP_STATE_COMPLETED').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_INCOMPLETE') != undefined) {
        this.incomplete = this.searchArraryForCount(res, 'TRIP_STATE_INCOMPLETE').tripcount;
      }
    }) 
  }
  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].tripstatus === value) {
        return arr[i];
      }
    }
  }
  tripData(type) {

  }

  generateMapData() {

    this.markersArr = [];

    setTimeout(() => {
      this.tripService.getAllTrips().subscribe(res => {
        //console.log(res);
        for (let i = 0; i < res.length; i++) {
          // Iterate over numeric indexes from 0 to 5, as everyone expects.
          let newobj = res[i].destinationAddress.location;

          let labeldetails = res[i];
          //let newreceiverName = res[i].receiverName;
          if (newobj != null) {
            let lat, lng, orderID, receiverName = {};

            lat = newobj.coordinates[0];
            lng = newobj.coordinates[1];

            this.markersArr.push({
              lat: lat,
              lng: lng,
              orderId: labeldetails.orderUniqueId,
              receiverName: labeldetails.receiverName
            })
          } else {

          }
        }


      })
    }, 500);

  }

}